import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function About() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("https://mocktest.bbmclasses.com/api/about.php")
      .then(res => res.text())
      .then(html => setContent(html))
      .catch(() => setContent("<p>Error loading page</p>"));
  }, []);

  return (
    <> 
   <Header/>
    <div
      style={{
        padding: "12px",
        marginTop: "60px",
        marginBottom: "70px",
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
 <Footer/>
 </>

  );
}